<template>
  <v-container fluid>
    <v-row>
      <v-col cols="auto">
        <v-tabs
          v-if="dashboardUser"
          v-model="selectedTab"
          show-arrows
        >
          <v-tab
            v-for="item in items"
            :key="item.name"
            :disabled="item.is_active == 0 || !dashboardUser.dashboard_ids.includes(item.id)"
            @click="tabChanges(item.index)"
          >
            {{ item.name }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === glassPurchseOrderIndex">
      <v-col class="pb-0">
        <div
          id="75f9cd77-f861-4733-a26c-73d418b852cf"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === glassQuantityIndex">
      <v-col class="pb-0">
        <div
          id="a5a0ccd6-2a47-490f-a0e2-54a0c19971b0"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === glassSheetIndex">
      <v-col class="pb-0">
        <div
          id="310c549d-f0fd-43a8-958f-9c8aa41b58d9"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === windowsIndex">
      <v-col class="pb-0">
        <div
          id="0c8ef179-61b1-41ef-9add-552095af94ce"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>

    <v-row v-show="selectedTab === windowsHistoryIndex">
      <v-col class="pb-0">
        <div
          id="52b53a00-a42e-4e48-bb0c-08ab53693c6d"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === windowsAssetHistoryIndex">
      <v-col class="pb-0">
        <div
          id="557d2b4f-6afa-42e1-bb8d-8135d1a4d0f7"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === shippingAccuracyIndex">
      <v-col class="pb-0">
        <div
          id="c34d7915-e576-4f78-b37f-7827136b9380"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === awdBreakdownIndex">
      <v-col class="pb-0">
        <div
          id="0c74b892-cfa1-4424-ac19-d798dc096991"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === awdPaintConsumptionIndex">
      <v-col class="pb-0">
        <div
          id="5d488150-a589-4d3d-9760-6f364ed86060"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === fieldWireTasksIndex">
      <v-col class="pb-0">
        <div
          id="7fc00a9f-f3c8-48c1-9bb8-ca9a0976ad4e"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === fieldwireTicketsSummary">
      <v-col class="pb-0">
        <div
          id="9c9b470a-6aba-4f65-81b1-613f589837d6"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === fieldwireProjectTasksIndex">
      <v-col class="pb-0">
        <div
          id="ed970238-7b7a-47bb-b60e-33fa6e7ce975"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === consumablesIndex">
      <v-col class="pb-0">
        <div
          id="dd19efb9-cb86-4d5d-af14-6aa390fba89a"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === windowsInQuarantineIndex">
      <v-col class="pb-0">
        <div
          id="3826fdb2-82bb-4ff0-913a-25f033a7a93e"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === panelsIndex">
      <v-col class="pb-0">
        <div
          id="c88e068a-2d5e-4520-976a-b8cdcf63f7f3"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === commercialIndex">
      <v-col class="pb-0">
        <div
          id="c1a90eb3-850c-4953-83f4-70d1921742fc"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === otdIndex">
      <v-col class="pb-0">
        <div
          id="45ee086f-6a30-4a47-82cb-cd84548e3109"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
    <v-row v-show="selectedTab === inspectionIndex">
      <v-col class="pb-0">
        <div
          id="4fd5ad06-1f05-4be1-8cfe-5ff29c484310"
          class="reportContainer"
          style="height: 87vh;"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as pbi from 'powerbi-client';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    selectedTab: null,
    items: [],
    dashboardUser: null,
    //TODO this needs to be dynamic, coming from DB
    glassPurchseOrderIndex: 0,
    glassPurchaseOrderId: '75f9cd77-f861-4733-a26c-73d418b852cf',
    glassQuantityIndex: 1,
    glassQuantityId: 'a5a0ccd6-2a47-490f-a0e2-54a0c19971b0',
    glassSheetIndex: 2,
    glassSheetId: '310c549d-f0fd-43a8-958f-9c8aa41b58d9',
    windowsIndex: 3,
    windowsId: '0c8ef179-61b1-41ef-9add-552095af94ce',
    windowsHistoryIndex: 4,
    windowsHistoryId: '52b53a00-a42e-4e48-bb0c-08ab53693c6d',
    windowsAssetHistoryIndex: 5,
    windowsAssetHistoryId: '557d2b4f-6afa-42e1-bb8d-8135d1a4d0f7',
    shippingAccuracyIndex: 6,
    shippingAccuracyId: 'c34d7915-e576-4f78-b37f-7827136b9380',
    awdBreakdownIndex: 7,
    awdBreakdownId: '0c74b892-cfa1-4424-ac19-d798dc096991',
    awdPaintConsumptionIndex: 8,
    awdPaintConsumptionId: '5d488150-a589-4d3d-9760-6f364ed86060',
    fieldWireTasksIndex: 9,
    fieldWireTasksId: '7fc00a9f-f3c8-48c1-9bb8-ca9a0976ad4e',
    fieldwireTicketsSummary: 10,
    fieldwireTicketsSummaryId: '9c9b470a-6aba-4f65-81b1-613f589837d6',
    fieldwireProjectTasksIndex: 11,
    fieldwireProjectTasksId: 'ed970238-7b7a-47bb-b60e-33fa6e7ce975',
    consumablesIndex: 12,
    consumablesId: 'dd19efb9-cb86-4d5d-af14-6aa390fba89a',
    windowsInQuarantineIndex: 13,
    windowsInQuarantineId: '3826fdb2-82bb-4ff0-913a-25f033a7a93e',
    panelsIndex: 14,
    panelsId: 'c88e068a-2d5e-4520-976a-b8cdcf63f7f3',
    commercialIndex: 15,
    commercialId: 'c1a90eb3-850c-4953-83f4-70d1921742fc',
    otdIndex: 16,
    otdId: '45ee086f-6a30-4a47-82cb-cd84548e3109',
    inspectionIndex: 17,
    inspectionId: '4fd5ad06-1f05-4be1-8cfe-5ff29c484310',
    previousIdreport: null,
    reports: [],
  }),

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    ...mapGetters([

    ]),
  },
  mounted() {
    this.getEmbedReports();
  },

  created() {
    this.init();
  },
  methods: {
    init() {
      this.getUsers();
    },

    async get() {
      this.items = await this.$api.dashboards.get();
      this.items.sort((a, b) => a.order - b.order);
      // eslint-disable-next-line no-return-assign, no-param-reassign
      this.items.forEach((item, index) => item.index = index);

      const firstItem = this.items.find((item) => item.is_active === 1 && this.dashboardUser.dashboard_ids.includes(item.id));
      if (firstItem) {
        this.selectedTab = firstItem.index;
      }
    },

    async getUsers() {
      const submitModel = {
        filters: {
          user_id: this.user.id,
        },
      };
      const res = await this.$api.dashboards.read(submitModel, null, 'read/users');
      if (!res) return;
      const firstIndex = 0;
      this.dashboardUser = res[firstIndex];
      this.get();
    },
    tabChanges(index) {
      const selectedReport = this.reports[index];
      this.embedReport(selectedReport);
    },
    async getEmbedReports() {
      //TODO rework this
      const reportMappings = [
        { index: this.glassPurchseOrderIndex, id: this.glassPurchaseOrderId },
        { index: this.procoreCorrespondenceIndex, id: this.procoreCorrespondenceId },
        { index: this.awdBreakdownIndex, id: this.awdBreakdownId },
        { index: this.awdPaintConsumptionIndex, id: this.awdPaintConsumptionId },
        { index: this.windowsIndex, id: this.windowsId },
        { index: this.glassQuantityIndex, id: this.glassQuantityId },
        { index: this.windowsHistoryIndex, id: this.windowsHistoryId },
        { index: this.windowsAssetHistoryIndex, id: this.windowsAssetHistoryId },
        { index: this.shippingAccuracyIndex, id: this.shippingAccuracyId },
        { index: this.glassSheetIndex, id: this.glassSheetId },
        { index: this.fieldWireTasksIndex, id: this.fieldWireTasksId },
        { index: this.fieldwireTicketsSummary, id: this.fieldwireTicketsSummaryId },
        { index: this.fieldwireProjectTasksIndex, id: this.fieldwireProjectTasksId },
        { index: this.consumablesIndex, id: this.consumablesId },
        { index: this.windowsInQuarantineIndex, id: this.windowsInQuarantineId },
        { index: this.panelsIndex, id: this.panelsId },
        { index: this.commercialIndex, id: this.commercialId },
        { index: this.otdIndex, id: this.otdId },
        { index: this.inspectionIndex, id: this.inspectionId },
      ];

      const res = await this.$api.dashboards.get('auth');
      if (!res) return;

      // Filter and map the reports based on the defined mappings
      this.reports = reportMappings
        .sort((a, b) => a.index - b.index)
        .map(({ id }) => res.find((item) => item.report_id === id) || null)
        .filter((report) => report !== null);

      if (this.reports.length > 0) {
        this.embedReport(this.reports[0]); // Embed the first report if available
      }
    },

    embedReport(report) {
      const { models } = pbi;
      const config = {
        type: 'report',
        tokenType: models.TokenType.Embed,
        accessToken: report.embed_token,
        embedUrl: report.embed_url,
        id: report.report_id,
        settings: {
          panes: {
            filters: {
              visible: false,
            },
          },
          bars: {
            statusBar: {
              visible: false,
            },
          },
        },
      };
      // if (report.report_id === this.glassPurchaseOrderId || report.report_id === this.awdPaintConsumptionId) {
      //   config.settings.zoomLevel = 1.25;
      // }

      if (this.previousIdreport) {
        const prevReportContainer = document.getElementById(this.previousIdreport);
        if (prevReportContainer) {
        // eslint-disable-next-line no-undef
          powerbi.reset(prevReportContainer);
        }
      }

      this.previousIdreport = report.report_id;

      const reportContainer = document.getElementById(`${report.report_id}`);

      if (reportContainer) {
        // eslint-disable-next-line no-undef
        powerbi.embed(reportContainer, config);
      }
    },
  },
};
</script>

<style scoped>
::v-deep iframe {
        border: none !important;
    }

    .reportContainer {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

::v-deep .v-slide-group__prev,
::v-deep .v-slide-group__next {
    opacity: 1;
}

::v-deep .v-slide-group__prev--disabled,
::v-deep .v-slide-group__next--disabled {
    visibility: hidden;
}
</style>
